<div class="container">
    <div class="dialog-header">
        <mat-icon class="close-button" (click)="close()" matTooltip="Close">cancel</mat-icon>
    </div>
    <div class="artifact-name">
        <h3>{{ artifactName }}</h3>        
    </div>
    <div class="codeLinkage_btn">
        <button *ngIf="!isCodeReviewCheckLoading && isActiveCodeLinkageAvailable && !isActiveCodeReviewAvailable" class="button" (click)="createCodeReview()" [featureActionState]="'CODE_REVIEW'">Create CodeReview</button>
        <button *ngIf="!isCodeReviewCheckLoading && isActiveCodeReviewAvailable" class="button" (click)="openCodeReview()">Open CodeReview</button>
    </div>
    <div class="accordion" [ngClass]="isAccordionTwoOpen && isAccordionOneOpen ? 'both-open' : !isAccordionTwoOpen && isAccordionOneOpen ? 'single-open' : ''">
        <div class="accordion-header" (click)="toggleAccordionOne()">
            <mat-icon>
                {{ isAccordionOneOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </mat-icon>
        </div>
        <div class="accordion-content" [ngClass]="isAccordionOneOpen ? 'active' : ''">
            <div class="flex-end">
                <div class="btn-group">
                    <button class="button" [disabled]="isAddingNewRow || isAddingGithubCommit" *ngIf="isGithubIntegrated" (click)="addGithubCommit()" [nonProjectFeatureNavState]="'GITHUB_INTEGRATION'">Add Git Commit</button>
                    <button class="button" (click)="onTemplateDownload()" [featureActionState]="'CODE_REVIEW'">Download Template</button>
                    <button class="button" (click)="fileInput.click()" [featureActionState]="'CODE_REVIEW'">Upload Template</button>
                    <input #fileInput type="file" (change)="onFileUpload($event)"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        style="display:none" />
                </div>
            </div>
            <div class="association-table-container">
                <table id="table1" class="accordion-table">
                    <thead>
                        <tr>
                            <th>Suite</th>
                            <th>Feature</th>
                            <th>Scenario</th>
                            <th>Step</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of artifactAssociationsList; let i = index">
                            <td>{{ row.suite_id ? row.suite_name : '-' }}</td>
                            <td>{{ row.feature_id ? row.feature_name : '-' }}</td>
                            <td>{{ row.scenario_id ? row.scenario_name : '-' }}</td>
                            <td>{{ row.step_id ? row.step_name : '-' }}</td>
                            <td><button class="delete-btn" mat-icon-button (click)="deleteArtifactAssociation(row, i)" [featureActionState]="'CODE_REVIEW'">
                                <mat-icon>delete</mat-icon>
                            </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <form [formGroup]="newRowForm" (ngSubmit)="onSubmitAdd()">
                <table id="table1" class="accordion-table" *ngIf="isAddingNewRow">
                    <tbody>
                        <tr>
                            <td class="width-25">
                                <mat-form-field class="width-100" appearance="fill">
                                    <mat-select (selectionChange)="onSuiteChange($event.value)" formControlName="suite">
                                        <mat-option [value]="null">-</mat-option>
                                        <mat-option *ngFor="let option of suiteOptions" [value]="option">
                                            {{ option.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td class="width-20">
                                <mat-form-field class="width-100" appearance="fill">
                                    <mat-select (selectionChange)="onFeatureChange($event.value)" formControlName="feature">
                                        <mat-option [value]="null">-</mat-option>
                                        <mat-option *ngFor="let option of featureOptions" [value]="option">
                                            {{option.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td class="width-20">
                                <mat-form-field class="width-100" appearance="fill">
                                    <mat-select (selectionChange)="onScenarioChange($event.value)" formControlName="scenario">
                                        <mat-option [value]="null">-</mat-option>
                                        <mat-option *ngFor="let option of scenarioOptions" [value]="option">
                                            {{option.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td class="width-25">
                                <mat-form-field class="width-100" appearance="fill">
                                    <mat-select (selectionChange)="onStepChange($event.value)" formControlName="step">
                                        <mat-option [value]="null">-</mat-option>
                                        <mat-option *ngFor="let option of stepOptions" [value]="option">
                                            {{option.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td class="width-10">
                                <div class="btn-group">
                                    <button class="btn btn-danger ck_btn" (click)="onCancelAdd()">Cancel</button>
                                    <button class="btn btn-primary ck_btn" type="submit" [featureActionState]="'CODE_REVIEW'">Submit</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
            <button *ngIf="!isAddingNewRow && !isAddingGithubCommit" class="add-btn" (click)="addNewRow()" [featureActionState]="'CODE_REVIEW'">+</button>
            <form [formGroup]="githubCommitForm" (ngSubmit)="onSubmitGithubCommitAdd()">
                <table id="table1" class="accordion-table" *ngIf="isAddingGithubCommit">
                    <tbody>
                        <tr>
                            <td class="width-18">
                                <mat-form-field class="width-100" appearance="fill">
                                    <mat-select (selectionChange)="onRepoChange($event.value)" formControlName="repo" [disabled]="githubRepoOptions.length === 0">
                                        <mat-option [value]="emptyDropDownOption" *ngIf="githubRepoOptions.length === 0">No Repos Available</mat-option>
                                        <mat-option *ngFor="let option of githubRepoOptions" [value]="option">
                                            {{ option }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td class="width-20">
                                <mat-form-field class="width-100" appearance="fill">
                                    <mat-select (selectionChange)="onBranchChange(githubCommitForm.get('repo').value,$event.value)" formControlName="branch" [disabled]="githubRepoBranchOptions.length === 0">
                                        <mat-option [value]="emptyDropDownOption" *ngIf="githubRepoBranchOptions.length === 0">No Branches Available</mat-option>
                                        <mat-option *ngFor="let option of githubRepoBranchOptions" [value]="option">
                                            {{ option }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td class="width-20">
                                <mat-form-field class="width-100" appearance="fill">
                                    <mat-select formControlName="commit" [disabled]="githubRepoCommitOptions.length === 0">
                                        <mat-option [value]="emptyDropDownOption" *ngIf="githubRepoCommitOptions.length === 0">No Commits Available</mat-option>
                                        <mat-option *ngFor="let option of githubRepoCommitOptions" [value]="option">
                                            {{ option.message }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <!-- <div *ngIf="isMoreCommitsAvailable">
                                <button (click)="loadMoreCommits(githubCommitForm.get('repo').value, githubCommitForm.get('branch').value)">
                                  Load More
                                </button>
                            </div> -->
                            <!-- New Column for File Upload -->
                            <td class="width-18">
                                <input type="file" required (change)="onProjectManagementFileChange($event)"
                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                            </td>
                            <td class="width-10">
                                <div class="btn-group">
                                    <button class="btn btn-danger ck_btn" (click)="onCancelGithubCommitAdd()">Cancel</button>
                                    <button class="btn btn-primary ck_btn" type="submit" [disabled]="isGithubCommitFormInValid()" [featureActionState]="'CODE_REVIEW'">Submit</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>

        </div>
    </div>
    <div class="accordion acd_btm" [ngClass]="isAccordionTwoOpen && isAccordionOneOpen ? 'both-open' : isAccordionTwoOpen && !isAccordionOneOpen ? 'single-open' : ''">
        <div class="accordion-header" (click)="toggleAccordionTwo()">
            <mat-icon>
                {{ isAccordionTwoOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </mat-icon>
        </div>
        <div class="accordion-content" [ngClass]="isAccordionTwoOpen ? 'active' : ''">
            <div *ngIf="shouldShowDangerMessage()"> 
                <span class="danger">Association removed; please review and update the records.</span>
            </div>
            <div class="mapping-table-container mylist" [ngClass]="shouldShowDangerMessage() ? 'mapping-table-msg-container-height' : 'mapping-table-container-height'" *ngIf="codeLinkedDataList.length > 0">
                <table id="table2" class="accordion-table">
                    <thead>
                        <tr>
                            <th *ngFor="let fieldName of codeLinkedDataList[0];">{{fieldName}}</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let row of codeLinkedDataList; let i = index">
                            <tr *ngIf="i > 0" [ngClass]="{ 'highlight-row-red': row[row.length - 2] === 'true' }">
                                <ng-container *ngFor="let data of row; let j = index; let lastCol = last">
                                    <td *ngIf="!(lastCol || j === row.length - 2 || j === row.length - 3)">
                                        <ng-container *ngIf="row[row.length - 3] === 'github' && codeLinkedDataList[0][j] === 'commit time'">
                                            {{ data | date:'MMM d, yyyy, h:mm:ss a'}}
                                        </ng-container>
                                        <ng-container *ngIf="row[row.length - 3] !== 'github' || codeLinkedDataList[0][j] !== 'commit time'">
                                            {{ data ? data : '-' }}
                                        </ng-container>
                                    </td>
                                </ng-container>
                                <td>
                                    <button class="delete-btn" mat-icon-button (click)="deleteCodeLinkageMapping(row, i)" [featureActionState]="'CODE_REVIEW'">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>